import React from "react";
import "./CustomerDetails.css";
import { AiOutlineClose } from "react-icons/ai";

function CustomerDetails({ isOpen, customer, onClose }) {
    if (!isOpen || !customer) return null;

    return (
        <>
            {/* ✅ Background overlay ensures popup is displayed properly */}
            <div className="customer-overlay" onClick={onClose}></div>

            <div className="customer-popup">
                <button className="close-btn" onClick={onClose}>
                    <AiOutlineClose />
                </button>
                <div className="popup-content">
                    {/* ✅ Close button properly positioned */}


                    <h2>Customer Details</h2>
                    <div className="popup-divider"></div>

                    <div className="customer-info">
                        <p><strong>NIC:</strong> {customer.NIC}</p>
                        <p><strong>First Name:</strong> {customer.FirstName}</p>
                        <p><strong>Last Name:</strong> {customer.LastName}</p>
                        <p><strong>Date of Birth:</strong> {new Date(customer.DOB).toISOString().split("T")[0]}</p>
                        <p><strong>Gender:</strong> {customer.Gender}</p>
                        <p><strong>Address:</strong> {customer.Address}</p>
                        <p><strong>Contact:</strong> {customer.ContactNumber}</p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CustomerDetails;
